import {ReactNode} from 'react';

import {Routes} from '../../_api/Api';
import SescLogoImg from '../../../img/logo-sesc.png';

interface AuthLayoutProps {
    children: ReactNode;
    title: string;
    subtitle: string;
    progress?: {
        current: number;
        steps: string[];
    };
}

const routes = new Routes();

export default function AuthLayout({children, title, subtitle, progress}: AuthLayoutProps) {
    return <div className="auth-sesc-layout">
        <aside className="auth-sesc-hero" aria-label="Espaço Digital Sesc RN">
            <div className="auth-sesc-grid" aria-hidden="true"/>
            <div className="auth-sesc-glow" aria-hidden="true"/>
            <div className="auth-sesc-hero-content">
                <img src={routes.img(SescLogoImg)} className="auth-sesc-logo auth-sesc-logo-inverse" alt="Sesc RN"/>
                <h1>Espaço Digital<br/>Sesc RN</h1>
                <p>Seu acesso aos serviços do Sesc RN, conectando você a benefícios, atividades e bem-estar.</p>
                <ul>
                    <li><i className="fa fa-id-card-o" aria-hidden="true"/> Solicite sua Credencial Sesc</li>
                    <li><i className="fa fa-globe" aria-hidden="true"/> Serviços 100% online</li>
                    <li><i className="fa fa-check-circle-o" aria-hidden="true"/> Acompanhe suas solicitações</li>
                </ul>
            </div>
        </aside>

        <section className="auth-sesc-form-panel">
            <div className="auth-sesc-dots" aria-hidden="true"/>
            <div className="auth-sesc-form-content">
                <a href={routes.get('/')} className="auth-sesc-brand">
                    <img src={routes.img(SescLogoImg)} className="auth-sesc-logo" alt="Sesc RN"/>
                </a>
                {progress && <ol className="auth-sesc-progress" aria-label="Etapas do cadastro">
                    {progress.steps.map((label, index) => {
                        const position = index + 1;
                        const status = position < progress.current ? 'is-complete' :
                            position === progress.current ? 'is-active' : '';
                        return <li className={status} key={label}
                                   aria-current={position === progress.current ? 'step' : undefined}>
                            <span>{position < progress.current ? <i className="fa fa-check" aria-hidden="true"/> : position}</span>
                            <small>{label}</small>
                        </li>;
                    })}
                </ol>}
                <h2>{title}</h2>
                <p className="auth-sesc-subtitle">{subtitle}</p>
                {children}
            </div>
        </section>
    </div>;
}
